import { styled } from '@linaria/react';
import { bodyFont, fonts, layout, semantic, space } from '../../theme/tokens';

export const FooterContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${space['space-300']} ${space['space-500']};
  gap: ${space['space-400']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space['space-600']} ${space['space-1000']};
  }
`;

export const FooterLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-100']};
`;

export const FooterTitle = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
`;

export const FooterTotal = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
`;
